export default {
  getInterview: (state) => state.interview,
};
